import _ from 'underscore';

import { memoizedMembershipsData } from 'bundles/catalogP/data/memberships';
import createLinkedModels from 'bundles/catalogP/lib/createLinkedModels';
import Memberships from 'bundles/catalogP/models/memberships';
import { Sessions } from 'bundles/course-sessions/models/Sessions';

export default function (options = {}) {
  return memoizedMembershipsData(options)
    .then(function (data) {
      if (data.linked && data.linked['onDemandSessions.v1'] && data.linked['onDemandSessionMemberships.v1']) {
        const sessionsGroup = _(data.linked['onDemandSessions.v1']).groupBy('courseId');
        const sessionMembershipsGroup = _(data.linked['onDemandSessionMemberships.v1']).groupBy('sessionId');

        const validSessionIds = Object.keys(sessionMembershipsGroup);

        data.elements.forEach((membership: $TSFixMe) => {
          const sessions = sessionsGroup[membership.courseId] || [];
          if (sessions.length) {
            const validSessions = sessions.filter((session) => validSessionIds.indexOf(session.id) >= 0);
            if (validSessions.length) {
              const activeSession = new Sessions(validSessions).getLastSession();
              membership.onDemandSessionId = activeSession.id;
              membership.onDemandSessionMemberships = validSessions.map(
                (session) => sessionMembershipsGroup[session.id]
              );
            }
          }
        });
      }

      if (data.linked && data.linked['v1Details.v1']) {
        data.linked['courses.v1'] = _(data.linked['courses.v1']).map(function (element) {
          if (element.courseType === 'v1.session' || element.courseType === 'v1.capstone') {
            element.v1Details = element.id;
            const sessions = _(data.linked['v1Sessions.v1']).reduce(function (sessionIds, session) {
              if (session.courseId === element.id) {
                // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
                sessionIds.push(session.id.toString());
              }

              return sessionIds;
            }, []);
            element.v1Sessions = sessions;
          }

          return element;
        });
      }

      if (data.linked && data.linked['v2Details.v1']) {
        data.linked['courses.v1'] = _(data.linked['courses.v1']).map(function (element) {
          if (element.courseType === 'v2.ondemand') {
            element.v2Details = _(data.linked['v2Details.v1']).findWhere({
              id: element.id,
            });
          }

          return element;
        });
      }

      if (data.linked && data.linked['vcMemberships.v1']) {
        const vcMembershipIds = _(data.linked['vcMemberships.v1']).pluck('id');
        data.elements = _(data.elements).map(function (element) {
          if (_(vcMembershipIds).contains(element.id)) {
            element.vcMembershipId = element.id;
          }

          return element;
        });
      }

      if (data.linked && data.linked['courses.v1']) {
        const courseIds = _(data.linked['courses.v1']).pluck('id');
        data.elements = _(data.elements)
          .chain()
          .filter(function (membership) {
            // Sometimes we get memberships surfaced without courses (they either deleted or shibboleth)
            // or hidden.
            return _(courseIds).contains(membership.courseId);
          })
          .compact()
          .value();
      }

      if (data.linked && data.linked['signatureTrackProfiles.v1']) {
        _(data.elements).each(function (element) {
          element.signatureTrackProfile = element.userId;
        });
      }

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'rawData' does not exist on type '{}'.
      if (options.rawData) {
        return data;
      }

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'withPaging' does not exist on type '{}'.
      if (options.withPaging) {
        return {
          elements: createLinkedModels(Memberships.prototype.resourceName, data),
          paging: data.paging,
        };
      }

      return createLinkedModels(Memberships.prototype.resourceName, data);
    })
    .fail(function (err) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'rawData' does not exist on type '{}'.
      if (options.rawData) {
        return null;
      }

      return new Memberships();
    });
}
